






















































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
@Component({
  components: {}
})
export default class Channel extends Vue {
  isFixed = false;
  offsetTop = 0;
  activeIndex = 0;
  tabs = ["伙伴体系", "成为伙伴", "伙伴合作", "伙伴激励"];
  bannerPic =
    "background-image: url(" + require("../../assets/pic16.png") + ")";

  mounted() {
    window.addEventListener("scroll", this.handleScroll);

    this.activeIndex = parseInt(this.$route.params.type) - 1;
    this.changeTab(parseInt(this.$route.params.type) - 1, 1);
  }
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  }
  handleScroll() {
    const scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop;
    this.isFixed = scrollTop > this.offsetTop ? true : false;
  }

  changeTab(index, id) {
    this.activeIndex = index;
    this.isFixed = false;
  }

  @Watch("$route", { immediate: true })
  onCatalogIdChange() {
    this.activeIndex = parseInt(this.$route.params.type) - 1;
  }
}
